import { Component, Input, OnInit } from '@angular/core';
import { Form, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
//import { MercadoPagoService } from 'src/app/services/mercado-pago/mercado-pago.service';
import { loadMercadoPago } from '@mercadopago/sdk-js';
import { HttpService } from 'src/app/services/http/http.service';
import { TranslateService } from '@ngx-translate/core';
import { FrontDeskService } from 'src/app/services/front-desk/front-desk.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { ReservationService } from 'src/app/services/reservation/reservation.service';
import { AngularFireDatabase } from '@angular/fire/compat/database';

declare var window: any;

@Component({
  selector: 'app-mercado-pago',
  templateUrl: './mercado-pago.component.html',
  styleUrls: ['./mercado-pago.component.css']
})
export class MercadoPagoComponent {
/*
  paymentMercadoPagoForm!: FormGroup;

  constructor(private mpService: MercadoPagoService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.mpService.initialize('APP_USR-d26304b1-407e-4cad-95cf-1e0a1e6a9060').then(() => {
      this.mpService.createCardForm('100.00', 'form-checkout');
      console.log('Entro en create MP');
    });

    this.paymentMercadoPagoForm = this.fb.group({
      //cardNumber: new FormControl('',[])
      cardNumber: ['',[]]
    });
  }

  async submitPayment(): Promise<void> {
    try
    {

    }
    catch(error)
    {

    }
  }*/

  /* Version form */
  @Input() reservationId: string = "";
  @Input() amount: number = 0;
  @Input() bankId: number = 0;
  private mp: any;
  loading: boolean = false;
  private cardForm: any;

  constructor(
    private httpService: HttpService,
      private translateService: TranslateService,
      private frontDeskService: FrontDeskService,
      private toastService: ToastService,
      private reservationService: ReservationService,
      private firebaseRealTimeService: AngularFireDatabase,
  ) {}

  ngOnInit(): void {
    this.reservationId,
    this.bankId,
    this.amount

    this.initializeMercadoPago();
  }

  private async initializeMercadoPago() {
    if(this.mp == null)
    {
      let keyPublic = await this.getBankKey();
      await loadMercadoPago();
      if(!this.mp)
        this.mp = new window.MercadoPago(keyPublic);
      if(!this.cardForm)
        this.createCardForm();
    }
  }

  public async getBankKey()
  {
    let bankContent = await this.httpService.MercadoPagoBank(this.bankId);
    
    return bankContent.data['credentials'];
  }

  private createCardForm() {
    try
    {
    this.cardForm = this.mp.cardForm({
      amount: String(this.amount),
      //autoMount: true,
      iframe: true,
      form: {
        id: "form-checkout",
        cardholderName: {
          id: "form-checkout__cardholderName",
          placeholder: "Titular de la tarjeta",
        },
        cardNumber: {
          id: "form-checkout__cardNumber",
          placeholder: "Numero de tarjeta",
        },
        expirationDate: {
          id: "form-checkout__expirationDate",
          placeholder: "MM/YY",
        },
        securityCode: {
          id: "form-checkout__securityCode",
          placeholder: "Código de seguridad",
        },
        issuer: {
          id: "form-checkout__issuer",
          placeholder: "Banco emisor",
        },
        installments: {
          id: "form-checkout__installments",
          placeholder: "Cuotas",
        },        
        cardholderEmail: {
          id: "form-checkout__cardholderEmail",
          placeholder: "E-mail",
        },
      },
      callbacks: {
        onFormMounted: (error: any) => {
          if (error) return console.warn("Form Mounted handling error: ", error);
          console.log("Form mounted");
        },
        onSubmit: async (event: Event) => {
          event.preventDefault();
          this.loading = true;

          let {
            paymentMethodId: payment_method_id,
            issuerId: issuer_id,
            cardholderEmail: email,
            amount,
            token,
            installments,
            identificationNumber,
            identificationType,
          } = this.cardForm.getCardFormData();

          /*fetch("http://localhost:8000/api/payment/mercado/sale", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              token,
              issuer_id,
              payment_method_id,
              transaction_amount: Number(amount),
              installments: Number(installments),
              description: "Descripción del producto",
              payer: {
                email,
                identification: {
                  type: identificationType,
                  number: identificationNumber,
                },
              },
            }),
          })
          .then((result) => console.log('featch Mercado pago',result));*/

          const { error, token:tokenRetry } = await this.cardForm.createCardToken();
          /*if(error)
            console.log('Error Mercado', error);*/

          token = tokenRetry

          let request = {
              token,
              issuer_id,
              payment_method_id,
              transaction_amount: Number(amount),
              external_reference:  this.reservationId,
              installments: Number(installments),
              description: 'ICARO ' +  this.reservationId,
              payer: {
                email,
                identification: {
                  type: identificationType,
                  number: identificationNumber,
                },
              },
              bankId: this.bankId,
            };

          if (!token) {
            console.error("Error: No se pudo generar el token de la tarjeta.");
            this.toastService.showToast('No se pudo generar el token de la tarjeta.' , 'error',{ timer: 4000 });
            return;
          }

          /*
          const cardNumber = (document.getElementById('form-checkout__cardNumber') as HTMLInputElement).value;
          const exipiation = (document.getElementById('form-checkout__expirationDate') as HTMLSelectElement).value;
          const security_code = (document.getElementById('form-checkout__securityCode') as HTMLInputElement).value;

          this.mp.fields.createCardToken({
            cardNumber,
            exipiation,
            security_code
          })
          .then((token: any) => {
            if (token.id) {
              // Enviar el token al servidor para procesar el pago
              console.log('Token generado:', token.id);
            } else {
              // Manejar errores de validación
              console.error('Error al generar el token:', token);
            }
          })
          .catch((error: any) => {
            console.error('Error al crear el token:', error);
          });*/

          let response = await this.httpService.MercadoPagoSale(request);
          this.responseMP(response);
          console.log('Loading', this.loading);
          //this.loading = false;
        },
        onFetching: (resource: any) => {
          console.log("Fetching resource: ", resource);
          //this.loading = true;

          // Animate progress bar
          const progressBar = document.querySelector(".progress-bar");
          progressBar?.removeAttribute("value");

          return () => {
            //this.loading = false;
            progressBar?.setAttribute("value", "0");
          };
        },
        onPaymentMethodsReceived: (error: any, paymentMethods: any) => {
          if (error) {
            console.error('Error al recibir métodos de pago:', error);
          } else {
            console.log('Métodos de pago disponibles:', paymentMethods);
          }
        },
        onIssuersReceived: (error: any, issuers: any) => {
          if (error) {
            console.error('Error al recibir emisores:', error);
          } else {
            console.log('Emisores disponibles:', issuers);
          }
        },
        onInstallmentsReceived: (error: any, installments: any) => {
          if (error) {
            console.error('Error al recibir cuotas:', error);
          } else {
            console.log('Cuotas disponibles:', installments);
          }
        },
        onCardTokenReceived: (error: any, token: any) => {
          if (error) {
            /*console.error('Error al recibir token de tarjeta:', error);
            let menssageError = error.map((e: any) => e.message).join('<br/>');
            this.toastService.showToast( menssageError , 'info',{ timer: 4000 });*/
            this.toastService.showToast( 'Favor de revisar los datos de la tarjeta.' , 'warning',{ timer: 4000 });
          } /*else {
            console.log('Token de tarjeta recibido:', token);
          }*/
        },
        onError: async (error: any, event: any) =>{
          //console.log('onError',error);
          //console.log('onError event',event);
          //console.log('onError loading', this.loading);
          this.loading = false;
          //await cardForm.createCardToken();
        }
      },
    });
    }
    catch(error)
    {
      console.log('error',error);
    }
  }
  
  public async responseMP(objMP: any){
    
    /*let reservation = await this.reservationService.getReservation(
      this.reservationId
    );*/
    const cardholderName = (document.getElementById('form-checkout__cardholderName') as HTMLInputElement).value;

    let errorMessage = '';
    this.loading = false;
    //console.log('status:',objMP.data['status'],'detalle:',objMP.data['status_detail']);

    if(objMP.data['status'] == 'approved')
    {
      //await this.translateService.instant('CONFIRMATION.SEND');
      let message = await this.translateService.instant('CONFIRMATION.SEND');
      this.toastService.showToast(message + ' ' + cardholderName, 'success', {timer: 3000});
      this.frontDeskService.sendConfirmation(this.reservationId);
    }
    else if(objMP.data['status'] == 'pending')
    {
      //this.toastService.showToast(reservation.clientName + ' tu pago esta pendiente' , 'info',{ timer: 4000 });
      this.toastMessage(objMP.data['status_detail'],cardholderName);
    }
    else if(objMP.data['status'] == 'rejected')
    {
      //this.toastService.showToast(reservation.clientName + ' tu pago fue rechazado' , 'info',{ timer: 4000 });
      this.toastMessage(objMP.data['status_detail'],cardholderName);
    }
    else if(objMP.data['status'])
    {
      this.toastMessage(objMP.data['status_detail'],cardholderName);
    }
    else
    {
      
      errorMessage = objMP.data['message'];

      /*if(objMP.data.xError == '' && objMP.data.xCvvResultCode != undefined)
      {
        errorMessage = 'CVV ' + objMP.data['xCvvResult'];
      }
      this.paymentCardKnoxForm.get('cardNumber')?.setValue('');
      this.paymentCardKnoxForm.get('expiry')?.setValue('');
      this.paymentCardKnoxForm.get('cvv')?.setValue('');*/
      if(errorMessage == 'Params Error')
        this.toastService.showToast('Se requieren todos los campos ' + cardholderName, 'error',{ timer: 4000 });
      else
        this.toastService.showToast(errorMessage + ' ' + cardholderName, 'error',{ timer: 4000, timerProgressBar: true });
    }
  }

  public toastMessage(statusDetail: string, clientName: string)
  {
    type Message = {[key:string]:string};
    const message:Message = {
      accredited: 'Pago acreditado.',
      partially_refunded: 'El pago se realizó con al menos un reembolso parcial.',
      pending_capture: 'El pago fue autorizado y está a la espera de ser capturado.',
      offline_process: 'Por una falta de procesamiento online, el pago está siendo procesado de manera offline.',
      pending_contingency: 'Falla temporal. El pago va a ser procesado de manera diferida.',
      pending_review_manual: 'El pago está en revisión para determinar su aprobación o rechazo.',
      pending_waiting_transfer: 'Para los casos de transferencia bancaria, el status_detail se obtiene al esperar a que el usuario termine el proceso de pago en su banco.',
      pending_waiting_payment: 'Para los casos de pagos offline, el mismo queda pendiente hasta que el usuario realice el pago.',
      pending_challenge: 'Para los casos de pagos con tarjeta de crédito, hay una confirmación pendiente a cause de un challenge.',
      bank_error: 'Si el medio de pago es transferencia bancaria, el pago fue rechazado por un error con el banco.',
      cc_rejected_3ds_mandatory: 'Pago rechazado por no tener el challenge 3DS cuando es obligatorio.',
      cc_rejected_bad_filled_card_number: 'Número de tarjeta incorrecto.',
      cc_rejected_bad_filled_date: 'Fecha de caducidad incorrecta.',
      cc_rejected_bad_filled_other: 'Detalles de la tarjeta incorrectos.',
      cc_rejected_bad_filled_security_code: 'Código de seguridad (CVV) incorrecto.',
      cc_rejected_blacklist: 'La tarjeta está inhabilitada, presente en problemas de robo/quejas/fraude.',
      cc_rejected_call_for_authorize: 'El método de pago requiere de una autorización previa por el valor de la transacción, que debe resolver el pagador con la entidad.',
      cc_rejected_card_disabled: 'La tarjeta está inactiva.',
      cc_rejected_duplicated_payment: 'Pago rechazado debido a que la transacción es duplicada del lado del proveedor de la tarjeta.',
      cc_rejected_high_risk: 'Rechazado por Prevención de Fraudes.',
      cc_rejected_insufficient_amount: 'El límite de la tarjeta es insuficiente para esta transacción.',
      cc_rejected_invalid_installments: 'Número inválido de cuotas/meses.',
      cc_rejected_max_attempts: 'Se excedió el número máximo de intentos.',
      //cc_rejected_other_reason: 'Error genérico.',
      cc_rejected_other_reason: 'Favor de verificar sus datos e intentelo nuevamente.',
      cc_rejected_time_out: 'La transacción fue rechazada debido al límite de tiempo.',
      cc_amount_rate_limit_exceeded: 'Rechazado porque superó el límite (CAP - Capacidad Máxima Permitida) del medio de pago.',
      rejected_high_risk: 'Rechazado por evaluación de riesgo, puntuación de crédito o sospecha de fraude.',
      rejected_insufficient_data: 'Rechazado debido a la falta de toda la información obligatoria requerida en el pago.',
      rejected_by_bank: 'Operación rechazada por el banco.',
      rejected_by_regulations: 'Pago rechazado por regulaciones.',
      rejected_by_biz_rule: 'Pago rechazado por reglas de negocio.',
    }

    if(message[statusDetail])
    {
      this.toastService.showToast(clientName + ' ' + message[statusDetail] , 'warning',{ timer: 4000 });
    }
    else
    {
      //Antes era Error genérico.
      this.toastService.showToast(clientName + ' Favor de verificar sus datos e intentelo nuevamente.' , 'warning',{ timer: 4000 });
    }

  }

  ngOnDestroy(): void 
  {
    const form = document.getElementById('form-checkout')
    //const form = document.getElementsByClassName('payment-form');

    if(this.cardForm?.unmount)
    {
      this.cardForm.unmount();
    }

    if(form)
    {
      form.innerHTML = '';
    }
  }
  /*
  @Input() reservationId: string = "";
  @Input() amount: number = 0;
  paymentMercadoPagoForm!: FormGroup;

  constructor(
    private fb: FormBuilder
  ){}

  ngOnInit(): void 
  {
    this.paymentMercadoPagoForm = this.fb.group({
      cardholderName: ['',[
        Validators.required,
        Validators.maxLength(50),
        Validators.pattern('[a-zA-ZÀ-ÖØ-öø-ÿ ]+')]],
      cardholderEmail: ['',[
        Validators.required,
        Validators.email
      ]],
      cardNumber: [],
      expirationDate: [],
      securityCode: [],
    });
  }

  onCardNumber(event: any)
  {
    const inputValue = event.target.value;

    const { cardholderName, cardNumber, expirationDate, securityCode, issuer } = this.paymentMercadoPagoForm.value;

    const paymentMethodElement = document.getElementById('paymentMethodId');
    const issuerElement = document.getElementById('form-checkout__issuer');
    const installmentsElement = document.getElementById('form-checkout__installments');

    const issuerPlaceholder = "Banco emisor";
    const installmentsPlaceholder = "Cuotas";

    let currentBin:any;
    inputValue.on('binChange', async (data:any) => {
      const { bin } = data;
      try {
        if (!bin && paymentMethodElement.value) {
          clearSelectsAndSetPlaceholders();
          paymentMethodElement.value = "";
        }

        if (bin && bin !== currentBin) {
          const { results } = await mp.getPaymentMethods({ bin });
          const paymentMethod = results[0];

          paymentMethodElement.value = paymentMethod.id;
          updatePCIFieldsSettings(paymentMethod);
          updateIssuer(paymentMethod, bin);
          updateInstallments(paymentMethod, bin);
        }

        currentBin = bin;
      } catch (e) {
        console.error('error getting payment methods: ', e)
      }
    });

    function clearSelectsAndSetPlaceholders() {
      clearHTMLSelectChildrenFrom(issuerElement);
      createSelectElementPlaceholder(issuerElement, issuerPlaceholder);

      clearHTMLSelectChildrenFrom(installmentsElement);
      createSelectElementPlaceholder(installmentsElement, installmentsPlaceholder);
    }

    function clearHTMLSelectChildrenFrom(element) {
      const currOptions = [...element.children];
      currOptions.forEach(child => child.remove());
    }

    function createSelectElementPlaceholder(element, placeholder) {
      const optionElement = document.createElement('option');
      optionElement.textContent = placeholder;
      optionElement.setAttribute('selected', "");
      optionElement.setAttribute('disabled', "");

      element.appendChild(optionElement);
    }

    // Este paso mejora las validaciones de cardNumber y securityCode
    function updatePCIFieldsSettings(paymentMethod) {
      const { settings } = paymentMethod;

      const cardNumberSettings = settings[0].card_number;
      cardNumberElement.update({
        settings: cardNumberSettings
      });

      const securityCodeSettings = settings[0].security_code;
      securityCodeElement.update({
        settings: securityCodeSettings
      });
    }
  }

  renderCalendar():void 
  {

  }*/
}